var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreoptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M8.6 20.2l12.7 12.6 12.6-12.6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 21.3,
    cy: 23.8,
    r: 2.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 21.3,
    cy: 17.1,
    r: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 21.3,
    cy: 10.5,
    r: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreoptions);
export default __webpack_public_path__ + "static/media/moreoptions.3cb159973d8a7317ea47a76648a71fd5.svg";
export { ForwardRef as ReactComponent };